<template>
  <div v-if="paymentLoading" class="payment-loading">
    <div class="loading-text-container">
      <span class="loading-text"
        >Payment in progress. This can take up to two minutes. Please do not
        reload the page while waiting
      </span>
      <span class="loading">{{ loading }}</span>
    </div>
    <div class="loading-bar-container">
      <progress-bar :options="options" :value="loadingBarValue" />
    </div>
    <!-- <div v-on:click="closeLoading()" class="close-button">
      <font-awesome-icon class="icon" icon="times-circle" />
    </div> -->
  </div>
</template>

<script>
export default {
  name: "payment-loading-view",
  data() {
    return {
      loading: "",
      loadingTimeout: null,
      loadingBarValue: 0,
      options: {
        text: {
          color: "#FFFFFF",
          shadowEnable: true,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Helvetica",
          dynamicPosition: false,
          hideText: false,
        },
        progress: {
          color: "#FFFFFF",
          backgroundColor: "#333333",
          inverted: false,
        },
        layout: {
          height: 100,
          width: 100,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 12,
          progressPadding: 0,
          type: "circle",
        },
      },
    };
  },
  props: {
    title: String,
  },
  mounted() {
    this.loadingTimeout = window.setInterval(() => {
      if (this.loading === "...") {
        this.loading = "";
      } else {
        this.loading += ".";
      }
    }, 500);
  },
  components: {},
  computed: {
    paymentLoading() {
      return this.$store.state.paymentLoading;
    },
  },
  watch: {
    paymentLoading(newValue) {
      if (newValue === true) {
        this.loadingBarValue = 0;
        let loadingBarInterval = window.setInterval(() => {
          this.loadingBarValue++;
          if (this.loadingBarValue >= 35) {
            clearInterval(loadingBarInterval);
            loadingBarInterval = window.setInterval(() => {
              this.loadingBarValue++;
              if (this.loadingBarValue >= 99) {
                clearInterval(loadingBarInterval);
              }
            }, 3000);
          }
        }, 200);
        window.addEventListener("beforeunload", this.onBeforeUnload);
      } else {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
      }
    },
  },
  methods: {
    closeLoading() {
      this.$store.commit("assignPaymentLoading", false);
    },
    onBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = "";
    },
  },
};
</script>

<style scoped>
.payment-loading {
  position: absolute;
  top: -20px;
  bottom: -20px;
  left: -60px;
  right: -60px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  align-items: center;
  color: white;
}

.loading-text-container {
  display: flex;
  font-size: 25px;
}

.loading-bar-container {
  display: flex;
  font-size: 25px;
  width: 100px;
  margin-top: 3px;
}

.loading {
  width: 20px;
  margin-left: 5px;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 25px;
  cursor: pointer;
}
</style>
